import {isDefined} from '@ls/js-utils';
import CalcType from 'state/Constants/CalcType';
import IssuerCountTypes from './IssuerCountTypes';
import scope from './scope';

export default class IssuerCountDefinition {
  #issuerCountType;
  #calcType;

  static getDefault = () => new IssuerCountDefinition({
    issuerCountType: IssuerCountTypes[1],
    calcType: CalcType.Account,
  });


  constructor(props = {}) {
    const {issuerCountType, calcType} = props;
    this.#issuerCountType = issuerCountType;
    this.#calcType = calcType
  }

  get issuerCountType() {
    return this.#issuerCountType;
  }

  get calcType() {
    return this.#calcType;
  }

  setIssuerCountType = (value) => new IssuerCountDefinition({
    ...this.copy(),
    issuerCountType: value,
  });

  setCalcType = (value) => new IssuerCountDefinition({
    ...this.copy(),
    calcType: value,
  });

  get complete() {
    return isDefined(this.#issuerCountType) && isDefined(this.#calcType);
  }

  get key() {
    return `${scope} - ${this.#issuerCountType}, ${this.#calcType}`;
  }

  copy = () => {
    return {
      issuerCountType: this.#issuerCountType,
      calcType: this.#calcType,
    }
  }
}
